const FAQ_ITEMS = [
  {
    id: 1,
    question: '什么是下拉式漫画？和传统翻页漫画有什么区别？',
    answer: '下拉式漫画是一种采用垂直滚动浏览方式的漫画阅读模式，读者只需上下滑动屏幕即可连续阅读，无需点击「下一页」按钮。相比传统翻页漫画，下拉式漫画阅读更加流畅自然，特别适合手机端阅读，能够带来更强的沉浸感和更好的阅读节奏。43423漫画网专注下拉式漫画，为你提供最佳的下拉式阅读体验。',
  },
  {
    id: 2,
    question: '43423漫画网上的漫画都是免费的吗？',
    answer: '是的，43423漫画网上的所有下拉式漫画资源均免费提供在线阅读。我们致力于打造一个绿色纯净的漫画阅读平台，让每一位漫画爱好者都能无障碍地享受下拉式阅读的乐趣。无需充值，无需订阅，打开即看。',
  },
  {
    id: 3,
    question: '支持哪些设备阅读下拉式漫画？',
    answer: '43423漫画网完美适配手机、平板和电脑端。无论是在通勤路上用手机追韩漫，还是在家用平板看日漫，都能享受流畅的下拉式阅读体验。平台采用响应式设计，自动适配不同屏幕尺寸，无需下载任何App，浏览器打开即可阅读。',
  },
  {
    id: 4,
    question: '漫画更新频率怎么样？多久更新一次？',
    answer: '43423漫画网保持每日更新的节奏，热门连载作品会第一时间同步更新。韩漫、日漫和国漫各有不同的更新周期，我们会在作品页标注下次更新时间，方便读者合理安排追漫计划。关注「新番速递」可以第一时间发现最新上架的作品。',
  },
  {
    id: 5,
    question: '如何找到我想看的下拉式漫画？',
    answer: '你可以通过首页的分类索引（韩漫下拉式、日漫下拉式、国漫专区等）按类型浏览，也可以使用搜索功能直接查找作品名称。此外，「热门漫画精选」和「漫画热度排行榜」也会帮你发现高人气的好作品。社区热门话题中还有大量漫友的真实推荐。',
  },
  {
    id: 6,
    question: '阅读时画面不清晰或者加载慢怎么办？',
    answer: '43423漫画网采用智能图片加载技术，会根据你的网络状况自动调整画质。如果遇到加载缓慢，建议检查网络连接或尝试切换网络环境。平台持续优化服务器性能，确保下拉式漫画的快速加载和高清显示。如有持续问题，欢迎通过反馈邮箱联系我们。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-medium mb-3">
            常见问答
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">关于下拉式漫画的常见问题</h2>
          <p className="mt-2 text-foreground-600 text-sm md:text-base">快速了解43423漫画网的下拉式阅读服务</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4 md:space-y-5">
          {FAQ_ITEMS.map((faq) => (
            <div key={faq.id} className="rounded-2xl bg-background-50 p-5 md:p-6">
              <h3 className="font-bold text-foreground-950 text-sm md:text-base mb-3 flex items-start gap-3">
                <span className="w-6 h-6 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-question-line text-sm"></i>
                </span>
                {faq.question}
              </h3>
              <p className="text-sm text-foreground-700 leading-relaxed pl-9">
                {faq.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}